export const MAX_BAR_HEIGHT_IN_PIXELS = 34;
export const MAX_BAR_WIDTH_IN_PIXELS = 34;

export const MAX_SUPPLIER_ON_CHART = 30;
export const MAX_LABEL_LENGTH = 20;